export const externalRedirectionMap: Record<string, string> = {
  'system-monitoring':
    'https://sso-d093bbdd.sso.duosecurity.com/saml2/sp/DIQTIC8Z1FVY4P1DDEVK/sso',
};
